<template lang="pug">
  app-page(title="Почтовые реестры" :fabItems="fabItems" :search-value="search.query"  @search="text => (search.query = text)")
    app-toolbar(:title="registry ? 'Партия №' + registry.batchName : 'Подготовка пакетов документов на отправку'")
      div(v-if="registry")
        app-toolbar-item.ml-2(label="Дата сдачи в ОПС" min-width="100"  @select="" @click.native="modals.edit = true") {{ registrySendDate }}
      app-toolbar-item.ml-2(label="Текущая партия" min-width="100"  @select="" @click.native="showReestrByDate()") {{ registryTitle }}
    
    .text-right
      v-chip.ma-2(v-if="search.pattern" color="#757575" text-color="white" small label close @click:close="search.query = null") Поиск:&nbsp;<b>{{ search.query }}</b>
      
    // Modal: Registrs: list reestrs
    //
    app-dialog(v-model="modals.reestrs" header="Сформированые реестры" :items="reestrItems")
    // Modal: Registry: print or download zip
    //
    app-dialog(v-model="modals.download.notice" header="Реестр" :items="printItems")

    // Modal: Registry: edit date send reestr
    //
    app-dialog(v-model="modals.edit" header="Изменить дата сдачи партии в ОПС" confirm-text="далее" @confirm="editDateReestr")
      div(v-if="registry")
        app-date-picker(v-model="registry.sendDate" view-format="DD.MM.YYYY")

    // Modal: Registry: date + list
    //
    app-dialog(v-model="modals.registry.notice" header="Выбрать реестр" confirm-text="далее" :confirm-disabled="modals.registry.currentId == null" @confirm="loadSelectedRegistry")
      app-date-picker(v-model="modals.registry.day" view-format="DD.MM.YYYY")
      app-select(v-model="modals.registry.currentId" :items="modals.registry.list" label="Реестр" item-text="name" item-value="id" :disabled="modals.registry.day.length == 0")
    
    // Список документов на отправку
    //
    div( v-if="displayLetters.length > 0")
      app-card(
        v-for="(l, index) in displayLetters" 
        :key="index" 
        :class="{'finger-pointer': isArchived(l)}"
        @click.native="toggleLetter(l)"
        @contextmenu.prevent.native="rightClickLetter(l)" 
      )
        app-card-header 
          span(v-if="!isArchived(l)")
            v-icon(v-if="isSelectedLetter(l)" style="margin-top:-8px;" color="green") check_box
            v-icon(v-else style="margin-top:-8px;") check_box_outline_blank
          | {{ l | letterStatus }}
          v-spacer
          .text-right пакет документов ({{ l.sessionDocs.length }}) готов к отправке
        app-card-body(:class="{ 'selected': isSelectedLetter(l)}")
          v-alert(v-if="l.notReady" type="info" dense text tile) Коверт и бар-код сформированы, но письмо не было передано в реестр
          app-card-headline {{ l.mailType.title }} | 
            span(v-if="l.envelopeFormat") формата {{ l.envelopeFormat.title }} | заказное | с простым уведомлением 
            span(v-else) заказная | с простым уведомлением
          app-card-title(v-html="highlight(l.addressee)")
          app-card-title(v-html="highlight(l.address)")
          app-card-caption(v-if="l.courtCase") дело № 
            span(v-html="highlight(l.courtCase.number)")
            | , судья: {{ judgeName(l) }}
          app-card-caption {{ l.weight }} грамм
            span(v-if="l.barCode" v-html="searchShpi(l)") 

    app-empty-list(v-else) Писем на отправку нет

    app-dialog-confirm(v-model="modals.deleteLetter" ref="deleteLetter" confirm-button="продолжить" @confirm="deleteLetterInRegistry")
      app-card-title Удалить отправление и сформировать реестр?

    app-dialog(v-model="dialogEditLetter" :items="letterItems" header="Выбранный пакет документов")

    app-dialog(v-model="dialogProps" ref="dialogProps" header="Изменить параметры отправления" width=400)
      v-form(v-if="selectedLetter" ref="newLetterForm")
        app-text-field(
          v-model="selectedLetter.weight" label="Грамм" 
          :rules="[weightChecker]"
          append-outer-icon="add"     @click:append-outer="incrementWeight"
          prepend-outer-icon="remove" @click:prepend-outer="decrementWeight"
        ) 
        app-button-action(@click="editLetter") Далее

    div(v-if="registry")
      app-button-action(:disabled="!isPrintAndDownloadReestr()" @click="modals.download.notice = true" fixed bottom center) 
        v-progress-circular(v-if="!isPrintAndDownloadReestr()" color="black" size="10" width="2" indeterminate)
        | распечатать и скачать
    app-button-action(v-else :disabled="lettersPreparedToRegistry.length==0" @click="sendLettersToRegistry()" fixed bottom center) 
      | сформировать и отправить реестр ({{ lettersPreparedToRegistry.length }})
</template>

<script>
import $_app_letter from "@/common/AppLetter.js"
import { letterService, reestrService } from '@/_services'
import { $_app_notifier } from "@/common/AppUtils.js"
import refreshable from '@/common/Refreshable'

import moment from 'moment'
moment.locale('ru')

import { AppDialogConfirm } from '@/components'
import { mapActions } from 'vuex'

export default {
  mixins: [$_app_notifier, refreshable],
  components: {
    [AppDialogConfirm.name]: AppDialogConfirm
  },

  mounted () {
    this.loadRegistry()
  },

  destroyed () {
    if (this.ping.token) {
      clearTimeout(this.ping.token)
    }
  },

  methods: {
    ...mapActions('letter', ['remove', 'updateLetter']),

    $_refresh () {
      if (!this.registry)
        this.loadRegistry()
    },

    deleteLetterInRegistry () {
      letterService.remove(this.letter.id).then(data => {
        console.log(data)
        this.registry.letters = this.registry.letters.map(item => item.id != this.letter.id)
        this.loadRegistryWithId(this.registry.id)
      })
    },

    searchShpi (letter) {
      if (!this.search.pattern || this.search.pattern.length == 0 ) {
        return ", " + letter.barCode
      }
      return ", " + letter.barCode.replace(new RegExp(this.search.pattern, "gi"), match => {
        return `<span style="color: #00BCD4; margin: 0px 1px;">${match}</span>`
      })
    },

    editDateReestr () {
      this.registry.sendDate += " " + moment().format("HH:mm")
      if (this.registry) reestrService.updateReestr(this.registry).then(data => {
        this.registry = data
        this.loadRegistryWithId(this.registry.id)
      })
    },

    showReestrByDate() {
      this.modals.registry.notice = true
      this.loadRegistryListByDate()
    },

    // Получить список всех писем для формирования реестра
    loadRegistry () {
      reestrService.list()
      .then(data => {
        data.sort((a, b) => a.id - b.id)
        this.letters = data
        this.registry = null
      })
    },

    // Получить список всех писем для формирования реестра
    loadSelectedRegistry () {
      this.modals.registry.notice = false
      this.loadRegistryWithId(this.modals.registry.currentId)
    },

    loadRegistryWithId(registryId) {
      reestrService.listLetters(registryId)
      .then(data => {
        this.registry = data

        let list = data.letters
        list.sort((a, b) => a.id - b.id)
        this.letters = list

        if (this.registry.status.name.indexOf("RESPONSE") < 0) {
          this.updateRegistryStatus()
        }
      })
    },

    isPrintAndDownloadReestr () {
      return this.registry.status.name.indexOf("RESPONSE") != -1 ? true : false
    },

    // Проверить статус: выбрано / не выбрано
    isSelectedLetter (l) {
      return l.status.name == $_app_letter.status.prepared_to_registry
    },

    isArchived (l) {
      return l.status.name == $_app_letter.status.in_registry
    },

    // Изменить статус письма: доабвить в реестр / убрать из реестра
    toggleLetter (l) {
      if (l.status.name == $_app_letter.status.prepared_to_registry) {
        this.selectedLetter = l
        this.dialogEditLetter = true
        // this.unselectLetter(l)
      } 
      else if (l.status.name != $_app_letter.status.in_registry) {
        this.selectLetter(l)
      }
      else if (l.status.name == $_app_letter.status.in_registry) {
        this.letter = l
        this.modals.deleteLetter = true
      }
    },

    rightClickLetter (l) {
      this.selectedLetter = l
      this.dialogEditLetter = true
    },

    incrementWeight () {
      this.selectedLetter.weight = this.weight * 1 + 1
    },

    decrementWeight () {
      this.selectedLetter.weight = this.weight * 1 > this.minWeight ? this.weight * 1 - 1 : this.weight * 1
    },

    editLetter() {
      this.dialogProps = false
      this.updateLetter(this.selectedLetter)
      this.letters = this.letters.filter(item => item.id!==this.selectedLetter.id)

    },

    // Загрузить список всех реестров на конкретную дату
    loadRegistryListByDate () {
      if (this.modals.registry.day) {
        console.log('Reg date', this.modals.registry.day)
        reestrService.listByDate(this.modals.registry.day)
        .then(data => {
          this.modals.registry.list = data.sort((a, b) => a.createDate.localeCompare(b.createDate) || a.name.localeCompare(b.name))
          this.modals.registry.currentId = null
        }) 
      }
      else {
        this.modals.registry.currentId = null
      }
    },

    // Выбрать письмо для формирования реестре
    selectLetter (l) {
      reestrService.selectLetter(l.id)
      .then(data => this.replaceLetter(data))
    },

    // Убрать письмо из формирующегося реестра (сменить статус обратно на READY)
    unselectLetter (l) {
      reestrService.unselectLetter(l.id)
      .then(data => this.replaceLetter(data))
    },

    // Найти в массиве элемент по ID и заменить его
    replaceLetter (l) {
      this.letters = this.letters.map(obj => obj.id === l.id ? l : obj)
    },

    // Отправить все отмеченные письма на регистрацию в реестр
    sendLettersToRegistry () {
      let ids = this.lettersPreparedToRegistry.map(obj => obj.id)
      reestrService.registry(ids)
      .then(data => {
        let listReestrs = []
        data.map(item => {
          let obj = { icon: 'open', title: item.name, action: () => this.loadRegistryWithId(item.id) }
          listReestrs.push(obj)
        })
        this.loadRegistry()
        this.reestrItems = listReestrs
        this.modals.reestrs = true
      })
    },

    // Открыть реестр для печати
    openRegistryById (id) {
      window.open(reestrService.defaultBaseURL() + 'reestr/' + id + '/file', '_blank')
    },

    printRegistry () {
      this.modals.download.notice = false
      window.open(reestrService.defaultBaseURL() + 'reestr/' + this.registry.id + '/file', '_blank')
    },

    generateRegistry () {
      this.modals.download.notice = false
      window.open(reestrService.defaultBaseURL() + 'reestr/' + this.registry.id + '/pdf/' + localStorage.getItem("courtAlias"), '_blank')
    },

    downloadZip () {
      this.modals.download.notice = false
      window.open(reestrService.defaultBaseURL() + 'reestr/' + this.registry.id + '/digfile', '_blank')
    },

    updateRegistryStatus () {
      if (this.ping.token) {
        clearTimeout(this.ping.token)
      }
      this.ping.token = setTimeout(() => {
        this.loadRegistryWithId(this.registry.id)
      }, 5000)
    },

    judgeName (letter) {
      if (letter.judge) {
        let judge = letter.judge
        let name = judge.lastName + ' ' + (judge.firstName ? judge.firstName.slice(0,1) + '.' : '') + (judge.middleName ? judge.middleName.slice(0,1) + '.' : '') 
        return name
      }
      return ''
    },

    highlight (t) {
      let { pattern } = this.search
      return pattern ? t.replace(new RegExp(pattern, "gi"), match => `<span style="color: #00BCD4; margin: 0px 1px;">${match}</span>`) : t
    },

    matchesSearch (obj) {
      let { pattern } = this.search
      let { address, addressee, barCode, courtCase = {} } = obj
      let number = courtCase ? courtCase.number : ""
      let list = [address, addressee, barCode, number].filter(item => item).map(item => item.toLowerCase())
      return list.find(val => val.includes(pattern))
    }
  },

  computed: {
    fabItems () {
      return this.registry ? [
        { icon: 'add', title: 'создать новую партию', action: () => this.loadRegistry() },
        { icon: 'add', title: 'cгенерировать реестр PDF', action: () => this.generateRegistry() },
      ] : []
    },

    printItems () {
      return [
        { icon: 'print', title: 'Распечатать реестр', action: () => this.printRegistry() }, 
        // нет в архиве данного файла, и в API почты этого файла тоже уже нет
        // { icon: 'cloud_download', title: 'Скачать zip архив для почты', action: () => this.downloadZip() },
      ]
    },

    letterItems () {
      return [
        { icon: 'edit', title: 'Изменить вес отправления', action: () => this.$refs.dialogProps.show() },
        { icon: 'cancel', title: 'Отменить сканирование', action: () => this.unselectLetter(this.selectedLetter) },
        ] 
    },

    weight () {
      return this.selectedLetter.weight * 1 || this.minWeight
    },

    minWeight () {
      return this.selectedLetter.mailType && this.selectedLetter.mailType.name == "BANDEROL" ? 100 : 1
    },

    weightChecker () {
      return this.selectedLetter.weight * 1 >= this.minWeight || "Недопустимый вес"
    },

    lettersPreparedToRegistry () {
      let list = this.letters.filter(obj => obj.status.name == $_app_letter.status.prepared_to_registry)
      return list
    },

    displayLetters () {
      // PREREESTR,READY
      // RESPONSE
      return this.letters
      .filter(obj => this.matchesSearch(obj))
      .map(obj => {
        obj.address = obj.address ? obj.address : 'Не указано'
        obj.addressee = obj.addressee ? obj.addressee : 'Не указано'
        obj.notReady = obj.status.name === 'RESPONSE'
        return obj
      }).sort((a, b) => a.createDate.localeCompare(b.createDate))
    },

    registryTitle () {
      return this.registry ? this.registry.name : moment(new Date()).format("DD.MM.YYYY") 
    },

    registrySendDate () {
      return this.registry ? moment(this.registry.sendDate).format("DD.MM.YYYY") : ''
    },

    isFormed () {
      return this.registry.status.value >= 2
    }
  },

  filters: {
    letterStatus (l) {
      return (l.status.name == $_app_letter.status.prepared_to_registry) 
      ? 'отсканировано'
      : (l.status.name == $_app_letter.status.in_registry)
      ? 'архив'
      : 'требуется сканирование'
    },
  },

  data () {
    return {
      // search: null,
      search: {
        query: '',
        pattern: '',
        timeoutToken: null
      },


      reestrItems: [],
      dialogDayMenu: false,
      dialogEditLetter: false,
      dialogProps: false,
      ping: {
        token: null
      },
      letters: [],
      letter: null,
      selectedLetter: null,
      registry: null,
      modals: {
        reestrs: false,
        edit: false,
        deleteLetter: false, 
        download: {
          notice: false
        },
        registry: {
          notice: false,
          currentId: null,
          list: [],
          day: moment().format('YYYY-MM-DD'),
          options: {
            disabledDate(time) {
              return time.getTime() > Date.now();
            },
          }
        }
      },
    }
  },

  watch: {
    'modals.registry.day': {
      handler: function () {
        this.loadRegistryListByDate()
      }
    },

    'search.query': {
      handler: function (val) {
        if (this.search.timeoutToken) {
          clearTimeout(this.search.timeoutToken)
        }
        this.search.timeoutToken = setTimeout(() => {
          let l = this.letters.find(obj => obj.barCode == val)
          if (l) {
            this.selectLetter(l)
            this.search.query = ''
            this.search.pattern = ''
          }
          else {
            this.search.pattern = val.toLowerCase()
          }
        }, 200)
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.w-100-prc {
  width: 100%;
}
.btn-color-text {
  font-family: 'Roboto', sans-serif;
    font-style: normal;
    font-weight: 300;
    font-size: 13px;
    line-height: 18px;
    color: #F2F2F2;
}

.highlightText {
  background: yellow;
}

.sud-font-slab-18 {
  font-family: Roboto Slab;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 16px;
}

.sud-dialog-header {
  background: #959595;
  color: #FFFFFF;
}

.sud-toolbar-item__activator {
  padding: 0px 8px;
  background: rgba(80, 82, 84, 0.4);
  border-radius: 5px;

  font-weight: normal;
  color: #F2F2F2;
  height: 24px;
  line-height: 24px;
}
</style>
